import React from 'react';

import styles from 'app/components/section-header/section-header.scss';

export const SectionHeader = ({ children }) =>
  <>
    <h3 className={`${styles.sectionHeader} ui-tertiary-title`}>
      {children}
    </h3>
    <hr className={styles.sectionSeparator} />
  </>;
